const axios = require("axios");
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

document.querySelectorAll(".ajax-form").forEach(item => {
  item.addEventListener("submit", event => {
    event.preventDefault();
    let target = event.target;
    axios.post(target.action, new FormData(event.target)).then(() => {
      target.classList.add("success");
      target.reset();
      console.log(event.target);
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "form_submission",
        formType:
          event.target.id === "newsletter" ? "newsletter" : "contact_form"
      });
    });

    [...item.elements].forEach(input => {
      input.addEventListener("focus", () => {
        target.classList.remove("success");
      });
    });
  });
});

const heightLimit = 200; /* Maximum height: 200px */

document.querySelectorAll(".textarea-auto").forEach(item => {
  item.addEventListener("input blur", event => {
    event.target.style.height =
      Math.min(event.target.scrollHeight, heightLimit) + "px";
  });
});
